export default __webpack_public_path__ + "static/media/icon-coin-gala.182ffeb8.svg";